/**
 * 組織の上限値（member_limit / max_product_registrations）を表示用の文字にする。
 * null と負数は無制限（config/stripe.php の plan_limits と Organization の約束。agency は -1）。
 */
export const formatLimit = (value: number | null | undefined): string => {
  if (value === null || value === undefined || value < 0) return '無制限';
  return value.toLocaleString();
};
